import React from 'react'
import Typewriter from "typewriter-effect";
import header from "../images/header2.jpg";
import { useTranslation } from "react-i18next";
import cookies from "js-cookie";

import { languages } from "../App";
const Header = () => {
    const { t } = useTranslation();
  const currentLangCode = cookies.get("i18next") || "en";
  const currentLang = languages.find((l) => l.code === currentLangCode);
  return (
    <div id='main'>
         <div className="tw-w-full tw-h-screen tw-relative tw-overflow-hidden header">
            <div className="tw-w-full tw-h-full">
                <img src={header} loading="lazy" className="tw-w-full tw-h-full tw-object-cover" />
            </div>
            <div className="overlay tw-absolute tw-top-0 tw-right-0 tw-w-full tw-h-screen tw-z-3 tw-bg-transparent-black">
                <div className="tw-h-full tw-w-full tw-flex tw-justify-start tw-items-center md:tw-justify-center tw-p-5">
                    <div className={`tw-text-white ${currentLangCode !== "en" ? "tw-mr-32 lg:tw-mr-18 md:tw-mr-10 sm:tw-mr-6 xs:tw-mr-4" : "tw-ml-32 lg:tw-ml-18 md:tw-ml-10 sm:tw-ml-6 xs:tw-ml-4"}  -tw-mt-16`} data-aos="zoom-in-down" data-aos-duration="2500">
                        <h1 className="tw-text-8xl md:tw-text-6xl sm:tw-text-5xl xs:tw-text-4xl">{t("Main_Title")}</h1>
                        {/* <p className="tw-text-4xl lg:tw-text-3xl md:tw-text-2xl sm:tw-text-lg xs:tw-text-sm tw-mt-14 sm:tw-mt-10 tw-font-light">لعبة تلفزيونية فريدة من نوعها تظهر مشروع شكل جديد</p> */}
                        <h4 className="tw-text-4xl lg:tw-text-3xl md:tw-text-2xl sm:tw-text-lg xs:tw-text-sm tw-mt-14 sm:tw-mt-10 tw-font-light">
                            <Typewriter 
                         options={{
                            autoStart : true , 
                            loop : true , 
                            delay : 70 ,
                            strings : [t("second_text")],
                         }}
                        />
                        </h4>
                        <button className="tw-text-white tw-mt-16 tw-p-3 md:tw-p-2 md:tw-text-sm tw-px-8 md:tw-px-5 tw-bg-third-gold tw-rounded-md hover:tw-bg-one-gold tw-duration-500 ">
                            {t("discover_more")}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Header